import type { MoodComponents } from "../../../common/types.ts";
export const controlValue = (years: number, interest: number, C: number) => {
 const expiryPressure = 1 / (1 + Math.exp(1.6 * (Math.max(0, years) - 1.5)));
 const renewalRisk = 1 - Math.max(0, Math.min(1, interest));
 const lossCap = .45 - .25 * Math.max(0, Math.min(1, C));
 return { expiryPressure, renewalRisk, lossCap, controlFactor: 1-lossCap*expiryPressure*renewalRisk };
};
export const tradeDisposition = (x: {
 age:number; yearsRemaining:number; renewalInterest:number; components:MoodComponents;
 traits:string[]; competitiveIndex:number; tradeRequest?:boolean;
}) => {
 const opportunity = x.age < 21 ? 0 : x.components.playingTime + (x.components.custom ?? [])
 .filter(r=>r.text.endsWith(": kept in the minors while ready to help")).reduce((s,r)=>s+r.amount,0);
 const interest=x.renewalInterest;
 const outlook=interest>=.8?'Very High':interest>=.6?'High':interest>=.4?'Medium':interest>=.2?'Low':'Very Low';
 const happiness=x.components.loyalty+x.components.facilities+x.components.trades+x.components.relatives+opportunity;
 const moodFactor=x.tradeRequest && x.age>=21 ? .96 : x.traits.includes('L') && happiness>0 ? 1+.02*Math.tanh(happiness/5) : 1;
 return {...controlValue(x.yearsRemaining,interest,x.competitiveIndex), yearsRemaining:x.yearsRemaining,
 renewalIndex:interest, renewalInterest:interest, outlook, opportunity, opportunityProtected:x.age<21,
 moodFactor, traitFactor:1, holdingFactor:1, factor:1};
};
export type ContractDisposition=ReturnType<typeof tradeDisposition>;
